import {
  getAccessToken,
  getUrlParam,
  isWxMiniProgram,
  isWxMiniProgramNew, //是否是微信小程序
  isWeixinBrowser, //是否是微信浏览器
  isAlipayMiniUa, //是否为支付宝小程序
  isQuickAppUa, //是否为快应用
  isHllApp, //是否是huolalaApp
  getFingerPrint
} from '@/utils';
import { mapState } from 'vuex';

let evtTrackingMixin = {
  computed: {
    ...mapState('global', ['uuid', 'env']),
    ...mapState('app', ['locationObj']),
    trigger_coordinates() {
      const { latitude, longitude } = this.locationObj || {};
      return `${latitude},${longitude}`;
    }
  },
  methods: {
    /**
     * 埋点接口
     * @param {String} evtType 事件类型（目前只允许下列类型）：CUSTOM=自定义类型；OPEN_WEBSITE=打开网页；CLICK_BTN=点击按钮；JOIN_ACT=参加活动；GET_PRIZE=获取奖品
     * @param {String} evtDesc 事件简述（这里按需求自己简要描述即可），部分约定：SHARE=点击分享；FROM_SHARE=从分享链接进入活动；FROM_SHARE_LOGIN_SUCCESS=从分享链接成功登录
     */
    evtTrack(evtType, evtDesc) {
      let access_token = getAccessToken();
      let wx_token = ''; //微信token
      let uuid = this.uuid;
      let event_type = evtType;
      let event_desc = evtDesc;
      let user_type = this.env;
      let link = location.href;
      let ref = getUrlParam('ref');
      let client, fingerprint;

      let rq = () =>
        this.$axios.post('/act/visit_log/save', {
          access_token,
          wx_token,
          uuid,
          event_type,
          event_desc,
          user_type,
          link,
          ref,
          client,
          fingerprint
        });

      if (isHllApp()) {
        if (this.env == 'driver') {
          client = 'DRIVER_APP';
        } else {
          client = 'USER_APP';
        }
      } else if (isWeixinBrowser()) {
        client = 'WEI_XIN';
      } else if (isWxMiniProgram()) {
        client = 'WX_MINI_APP';
      } else {
        client = 'BROWSER';
      }
      getFingerPrint().then(fp => {
        fingerprint = fp;
        rq();
      });
    },
    /**
     *
     * @param {*} actType 司机端:dact_data / 用户端:uact_data
     * @param {*} param
     */
    async visitLog(pageName, btnName, options = {}) {
      // console.log('visitLog:', pageName, btnName, JSON.stringify(options));
      let actType = '';
      if (options.actEventType) {
        actType = options.actEventType;
      } else {
        actType =
          this.env == 'driver'
            ? 'dact_data'
            : this.env == 'company'
            ? 'cact_data'
            : 'uact_data';
      }
      if (btnName === '') btnName = null;
      if (pageName === '') pageName = null;
      let data = {
        page_title: document.title,
        page_name: pageName,
        trigger_coordinates: this.trigger_coordinates,
        ...(options.actEventType
          ? { button_type: btnName }
          : { button_name: btnName }),
        ref: getUrlParam('ref') || getUrlParam('_ref'),
        uuid: this.uuid,
        version: getUrlParam('version') || getUrlParam('app_ver')
      };
      if (options && typeof options == 'object') {
        data = { ...data, options };
      }
      if (options.shareType) {
        data.share_type = options.shareType;
      }
      try {
        await isWxMiniProgramNew();
        data.platform_type = '微信小程序';
      } catch {
        var platformType = '其他浏览器';
        if (isWeixinBrowser()) {
          platformType = '微信浏览器';
        }
        if (isHllApp()) {
          platformType = '货拉拉app';
        }
        if (isAlipayMiniUa()) {
          platformType = '支付宝小程序';
        }
        if (isQuickAppUa()) {
          platformType = '快应用';
        }
        data.platform_type = platformType;
      }
      Object.assign(data, options);
      console.log(actType, 'actType');
      this.$sensors.track(actType, data);
    }
  }
};

export default Vue => {
  Vue.mixin(evtTrackingMixin);
};
